import React, { FC, memo } from 'react';
import { ProductViewModel } from '~/lib/data-contract';
import { CMSLink, Typography } from '~/shared/components';
import { useTranslation } from '~/shared/utils';
import styles from './color-selector.module.css';
import clsx from 'clsx';
import { queries } from '~/theme';
import ProductImage from '~/shared/components/product-image/product-image.component';

export type Props = Pick<ProductViewModel, 'colors'> & { activeColorId?: string | null };

const ColorSelector: FC<Props> = memo((props) => {
    const { colors = [], activeColorId } = props;
    const { translate } = useTranslation();

    const selectedColor =
        colors?.find((color) => color.productColorId === activeColorId)?.color || '';

    return (
        <div>
            <Typography variant="caption" as="div" uppercase>
                {selectedColor &&
                    translate('productDetails.activeColorVariant', { activeColor: selectedColor })}
            </Typography>
            <nav className={styles.nav}>
                {colors.map(({ image, productColorId, color, url }) => (
                    <CMSLink
                        key={productColorId}
                        href={url}
                        replace
                        title={color || ''}
                        className={clsx(styles.link, {
                            [styles.active]: productColorId === activeColorId,
                        })}
                    >
                        <ProductImage
                            sizes={`${queries.md} 80px, 48px`}
                            image={image}
                        />
                    </CMSLink>
                ))}
            </nav>
        </div>
    );
});

ColorSelector.displayName = 'ColorSelector';
export default ColorSelector;
